<template>
  <div class="tab-toggle">
    <div
      class="item"
      :class="[activeId == item.id ? 'active' : '']"
      :key="item.value"
      v-for="item in list"
      @click="toggle(item.id, item)"
    >
      {{ item.name }}
      <span
        class="tag"
        :class="item.number <= 0 ? 'dot' : ''"
        v-if="item.isTag"
      >
        <span class="text">{{ item.number > 90 ? "90+" : item.number }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { ref, toRefs } from "vue";
export default {
  name: "TabToggle",
  props: {
    defaultId: {
      type: [Number, String],
      default: 1,
    },
    list: {
      type: Array,
      default() {
        return [
          {
            name: "待处理",
            id: "pending",
            isTag: false,
            number: 0,
          },
          {
            name: "已处理",
            id: "processed",
            isTag: false,
          },
          {
            name: "抄送我",
            id: "copy",
            isTag: false,
            // number: 0,

          },
          {
            name: "我发起的",
            id: "initiator",
            isTag: false,
          },
        ];
      },
    },
  },
  setup(props, { emit }) {
    let { defaultId } = toRefs(props);
    const activeId = ref(defaultId.value);
    const toggle = (id, item) => {
      activeId.value = id;
      emit("onChange", item);
    };

    return {
      activeId,
      toggle,
    };
  },
};
</script>

<style lang="less" scoped>
.tab-toggle {
  position: relative;
  display: flex;
  height: 44px;
  padding: 0 15px;
  background-color: #fff;
  .item {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &.active {
      // color: #4275fd;
      font-weight: 600;
    }
    &.active::after {
      background-color: #4275fd;
    }
    &::after {
      position: absolute;
      display: inline-block;
      content: " ";
      width: 15px;
      height: 3px;
      bottom: 3px;
      left: calc(50% - 8px);
      border-radius: 3px;
      background-color: transparent;
    }
    .tag {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 10px;
      right: 10px;
      font-size: 10px;
      width: 12px;
      height: 12px;
      color: #fff;
      border-radius: 50%;
      background-color: #fe4f54ff;
      &.dot {
        width: 10px;
        height: 10px;
        top: 12px;
        right: 12px;
      }
      .text {
        transform: scale(0.6);
      }
    }
  }
}
</style>
